import React, { useEffect, useState } from "react";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import CustomizedSwitches from "../ManageVietcomBank/component/CustomizedSwitches";
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import TextField from '@material-ui/core/TextField';
import { toast } from 'react-toastify';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Checkbox from '@material-ui/core/Checkbox';
import { vietinBankService } from './services/vietinBankService';

const DEFAULT_PASSWORD = "*******";
const NEW_CONFIRM_TITLE = "TẠO TÀI KHOẢN";
const OLD_CONFIRM_TITLE = "CẬP NHẬT";

function createData(id, accountNumber, isEnable, lastUpdate, password, username, propType, accountLevel, ownerName, aliasNumber, aliasName, status) {
  if (propType === "VTB_PROP" || propType === "VietinBank") {
    propType = "VietinBank";
  } else {
    propType = propType || "Chưa cập nhật";
  }
  if (lastUpdate !== null && lastUpdate !== undefined) {
    const date = new Date(lastUpdate);
    const formatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Asia/Ho_Chi_Minh',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
    lastUpdate = formatter.format(date);
  }
  password = DEFAULT_PASSWORD;
  if (accountLevel === null || accountLevel === undefined) accountLevel = 2;
  if (!status) status = 'UNKNOWN';
  return { id, accountNumber, isEnable, lastUpdate, password, username, propType, accountLevel, ownerName, aliasNumber, aliasName, status };
}

const useStyles = makeStyles({
  root: { margin: 100 },
  table: { minWidth: 500 },
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: 14,
    border: '1px solid #dadde9',
    '& p': { margin: '4px 0' },
    '& p:first-child': {
      fontWeight: 'bold',
      marginBottom: 8,
    }
  },
  actionButton: {
    fontSize: '0.75rem',
    padding: '4px 8px',
  },
});

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  if (!Array.isArray(array)) {
    return [];
  }
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) return -1;
  if (b[orderBy] > a[orderBy]) return 1;
  return 0;
}

function formatAmountWithComma(amount) {
  if (amount === null || amount === undefined) return '';

  const raw = String(amount).trim();
  if (!raw) return '';

  const sign = raw.startsWith('+') || raw.startsWith('-') ? raw[0] : '';
  const numberPart = sign ? raw.slice(1) : raw;
  const normalizedNumberPart = numberPart.replace(/,/g, '');

  if (!/^\d+(\.\d+)?$/.test(normalizedNumberPart)) {
    return raw;
  }

  const [integerPart, decimalPart] = normalizedNumberPart.split('.');
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const formattedNumber = decimalPart !== undefined ? `${formattedInteger}.${decimalPart}` : formattedInteger;

  return `${sign}${formattedNumber}`;
}

const headCells = [
  { id: 'isSelected', disablePadding: false, label: '' },
  { id: 'accountNumber', disablePadding: true, label: 'Số tài khoản' },
  { id: 'accountLevel', disablePadding: true, label: 'Level tài khoản' },
  { id: 'username', disablePadding: false, label: 'Tên đăng nhập' },
  { id: 'ownerName', disablePadding: false, label: 'Tên chủ tài khoản' },
  { id: 'aliasNumber', disablePadding: false, label: 'Alias number' },
  { id: 'aliasName', disablePadding: false, label: 'Alias name' },
  { id: 'isEnable', disablePadding: false, label: 'Trạng thái' },
  { id: 'lastUpdate', disablePadding: false, label: 'Ngày cập nhật' },
  { id: 'action', disablePadding: false, label: 'Hành động' },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead style={{ backgroundColor: '#76b5c5' }}>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={'right'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { numSelected, handleClickOpenDialog, onRemoveAccounts } = props;

  return (
    <Toolbar className={classes.root}>
      <Typography className={classes.title} variant="h6" id="tableTitle" component="div">
        Danh sách Account Ngân hàng
      </Typography>
      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton aria-label="delete" onClick={onRemoveAccounts}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Add account">
          <IconButton aria-label="filter list" onClick={() => handleClickOpenDialog(-1)}>
            <AddCircleIcon fontSize="large" />
          </IconButton>
        </Tooltip>
      )}
    </Toolbar>
  );
};

function ManageVietinBank() {
  const classes = useStyles();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [selected, setSelected] = React.useState([]);
  const [rows, setRows] = React.useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [openHistoryModal, setOpenHistoryModal] = useState(false);
  const [transactions, setTransactions] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [buttonName, setButtonName] = useState("TẠO TÀI KHOẢN");
  const [loading, setLoading] = useState({
    fetch: false,
    save: false,
    delete: false,
    history: false
  });
  const [verifyingRowId, setVerifyingRowId] = useState(null);
  const [otp, setOtp] = useState('');

  const [newAccount, setNewAccount] = useState({
    id: null,
    accountNumber: "",
    accountLevel: 2,
    username: '',
    ownerName: '',
    aliasNumber: '',
    aliasName: '',
    password: '',
    propType: 'VietinBank',
    isEnable: false,
    lastUpdate: new Date().getTime(),
  });

  function resetNewAccount() {
    setNewAccount({
      accountNumber: "",
      accountLevel: 2,
      username: '',
      ownerName: '',
      aliasNumber: '',
      aliasName: '',
      password: '',
      propType: 'VietinBank',
      isEnable: false,
    });
  }

  const handleClickOpenDialog = (index) => {
    if (index !== -1) {
      const oldRow = rows[index];
      setNewAccount({
        id: oldRow.id,
        accountNumber: oldRow.accountNumber,
        accountLevel: oldRow.accountLevel,
        username: oldRow.username,
        ownerName: oldRow.ownerName,
        aliasNumber: oldRow.aliasNumber || '',
        aliasName: oldRow.aliasName || '',
        password: oldRow.password,
        propType: oldRow.propType,
        isEnable: oldRow.isEnable,
        lastUpdate: oldRow.lastUpdate
      });
      setButtonName(OLD_CONFIRM_TITLE);
    } else {
      setButtonName(NEW_CONFIRM_TITLE);
    }
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    resetNewAccount();
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const handleInputChange = (e) => {
    let { name, value } = e.target;

    if (name === "accountLevel") {
      if (value === '') {
        value = '';
      } else if (/^\d+$/.test(value)) {
        value = Number(value);
      } else {
        return;
      }
    } else if (name === "isEnable") {
      value = e.target.checked;
    }

    setNewAccount((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddAccount = async () => {
    const normalizedPassword = newAccount.password === DEFAULT_PASSWORD ? '' : newAccount.password;
    const normalizedLastUpdate = newAccount.lastUpdate ? null : newAccount.lastUpdate;

    if (buttonName === NEW_CONFIRM_TITLE &&
      (!newAccount.accountNumber || !newAccount.username || !newAccount.password || !newAccount.ownerName)) {
      return toast.warning("Bạn cần điền đầy đủ thông tin khi tạo");
    }

    if (buttonName === OLD_CONFIRM_TITLE &&
      (!newAccount.accountNumber || !newAccount.username)) {
      return toast.warning("Bạn cần điền đầy đủ thông tin");
    }
    if (Number(newAccount.accountLevel) < 2) {
      return toast.warning("accountLevel phải >= 2");
    }

    const accountToSave = {
      ...newAccount,
      password: normalizedPassword,
      lastUpdate: normalizedLastUpdate,
      accountLevel: Number(newAccount.accountLevel),
      aliasNumber: newAccount.aliasNumber || null,
      aliasName: newAccount.aliasName || null,
      propType: "VietinBank"
    };

    const isSuccess = await createAccount(accountToSave);
    if (isSuccess) {
      setOpenDialog(false);
      resetNewAccount();
    }
  };

  const handleRemoveAccounts = async () => {
    if (!selected.length) return;
    setOpenConfirmDialog(true);
  };

  const handleConfirmDelete = async () => {
    setLoading(prev => ({ ...prev, delete: true }));
    try {
      const response = await vietinBankService.deleteAccounts(selected);
      if (response.status === "OK") {
        await getAccount();
        toast.success(response.message || "Xoá tài khoản thành công");
      } else {
        toast.warning(response.message || "Không thể xoá tài khoản");
      }
    } catch (error) {
      toast.error(error.message || "Đã xảy ra lỗi khi xoá tài khoản");
    } finally {
      setLoading(prev => ({ ...prev, delete: false }));
      setOpenConfirmDialog(false);
      setSelected([]);
    }
  };

  const handleVerifyClick = async (rowId) => {
    setVerifyingRowId(rowId);
    setOtp('');
    const response = await vietinBankService.getOTP(rowId);
    if (response.status === 'OK') {
      toast.success(response.message || 'OTP đã được gửi!');
    } else {
      toast.warning(response.message || 'Yêu cầu OTP thất bại.');
      setVerifyingRowId(null);
    }
  };

  const handleVerify = async (accountId, otpCode) => {
    if (!otpCode) return toast.warning("Vui lòng nhập mã OTP");
    setLoading(prev => ({ ...prev, save: true }));
    try {
      const response = await vietinBankService.verifyOTP(accountId, otpCode);
      if (response.status === 'OK') {
        toast.success(response.message || 'Xác thực tài khoản thành công!');
        await getAccount();
      } else {
        toast.warning(response.message || 'Xác thực thất bại.');
      }
    } catch (error) {
      toast.error(error.message || 'Đã xảy ra lỗi khi xác thực.');
    } finally {
      setVerifyingRowId(null);
      setOtp('');
      setLoading(prev => ({ ...prev, save: false }));
    }
  };

  const handleViewHistory = async (row) => {
    setSelectedAccount(row);
    setLoading(prev => ({ ...prev, history: true }));
    try {
      const response = await vietinBankService.getTransactions(row.id);
      if (response?.status && response.status !== "OK") {
        toast.warning(response.message || "Không thể tải lịch sử giao dịch.");
        setTransactions([]);
        setOpenHistoryModal(false);
        return;
      }

      const rawTransactions = Array.isArray(response?.data?.transactions)
        ? response.data.transactions
        : Array.isArray(response?.transactions)
          ? response.transactions
          : [];

      if (rawTransactions.length > 0) {
        const normalizedTransactions = rawTransactions.map((tx) => {
          const tranDate = tx?.tranDate || '';
          const [datePart = tx?.date || 'NULL', timePart = tx?.time || 'NULL'] = tranDate.split(' ');
          const amountValue = String(tx?.amount ?? '');
          const normalizedAmount = tx?.amount !== undefined && tx?.amount !== null
            ? amountValue
            : '';

          return {
            date: tx?.date || datePart,
            time: tx?.time || timePart,
            message: tx?.message || '',
            amount: normalizedAmount
          };
        });

        setTransactions(normalizedTransactions);
        setOpenHistoryModal(true);
      } else {
        toast.warning(response?.message || "Không có giao dịch nào.");
        setTransactions([]);
        setOpenHistoryModal(true);
      }
    } catch (error) {
      toast.error(error.message || "Đã xảy ra lỗi khi tải lịch sử giao dịch.");
      setTransactions([]);
      setOpenHistoryModal(false);
    } finally {
      setLoading(prev => ({ ...prev, history: false }));
    }
  };

  const handleCloseHistoryModal = () => {
    setOpenHistoryModal(false);
    setTransactions([]);
    setSelectedAccount(null);
  };

  useEffect(() => {
    getAccount();
  }, []);

  const getAccount = async () => {
    setLoading(prev => ({ ...prev, fetch: true }));
    try {
      const response = await vietinBankService.getAccounts();
      let accounts = [];

      // New API contract: { status, message, data: [] }
      if (response?.status === "OK" && Array.isArray(response?.data)) {
        accounts = response.data;
      } else if (response?.status && response.status !== "OK") {
        toast.warning(response?.message || "Không thể tải danh sách tài khoản");
        setRows([]);
        return;
      } else if (Array.isArray(response)) {
        accounts = response;
      } else if (Array.isArray(response?.data?.account)) {
        accounts = response.data.account;
      } else if (Array.isArray(response?.data)) {
        accounts = response.data;
      }

      if (Array.isArray(accounts)) {
        accounts = accounts.map((e) =>
          createData(
            e.id,
            e.accountNumber,
            e.isEnable,
            e.lastUpdate,
            e.password,
            e.username,
            e.propType,
            e.accountLevel,
            e.ownerName,
            e.aliasNumber,
            e.aliasName,
            e.status
          )
        );
        setRows(accounts);
      } else {
        toast.warning(response?.message || "Không thể tải danh sách tài khoản");
        setRows([]);
      }
    } catch (error) {
      toast.error(error.message || "An error occurred while fetching accounts");
    } finally {
      setLoading(prev => ({ ...prev, fetch: false }));
    }
  };

  const createAccount = async (account) => {
    setLoading(prev => ({ ...prev, save: true }));
    try {
      const response = await vietinBankService.createOrUpdateAccount(account);
      if (response.status === "OK") {
        await getAccount();
        toast.success("Lưu tài khoản thành công");
        return true;
      } else {
        toast.warning(response.message || "Failed to create/update account");
      }
    } catch (error) {
      toast.error(error.message || "An error occurred while saving the account");
    } finally {
      setLoading(prev => ({ ...prev, save: false }));
    }
    return false;
  };

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <EnhancedTableToolbar
          numSelected={selected.length}
          handleClickOpenDialog={handleClickOpenDialog}
          onRemoveAccounts={handleRemoveAccounts}
        />
        <TableContainer>
          <Table className={classes.table} aria-labelledby="tableTitle" size={'medium'} aria-label="enhanced table">
            <EnhancedTableHead order={order} orderBy={orderBy} onRequestSort={handleRequestSort} />
            <TableBody>
              {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
                const isItemSelected = isSelected(row.id);
                const labelId = `enhanced-table-checkbox-${index}`;
                return (
                  <TableRow
                    hover
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={row.id}
                    selected={isItemSelected}
                    onDoubleClick={() => handleClickOpenDialog(index)}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={isItemSelected}
                        onChange={(event) => handleClick(event, row.id)}
                        inputProps={{ 'aria-labelledby': labelId }}
                      />
                    </TableCell>
                    <TableCell component="th" id={labelId} scope="row" align="right">{row.accountNumber}</TableCell>
                    <TableCell component="th" scope="row" align="right">{row.accountLevel}</TableCell>
                    <TableCell align="right">{row.username}</TableCell>
                    <TableCell align="right">{row.ownerName}</TableCell>
                    <TableCell align="right">{row.aliasNumber === null ? 'NULL' : row.aliasNumber}</TableCell>
                    <TableCell align="right">{row.aliasName === null ? 'NULL' : row.aliasName}</TableCell>
                    <TableCell align="right">
                      <CustomizedSwitches state={row.isEnable} />
                    </TableCell>
                    <TableCell align="right">{row.lastUpdate === null ? 'NULL' : row.lastUpdate}</TableCell>
                    <TableCell align="right">
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '8px' }}>
                        <Button
                          variant="outlined"
                          onClick={() => handleViewHistory(row)}
                          disabled={loading.history && selectedAccount?.id === row.id}
                          className={classes.actionButton}
                        >
                          {loading.history && selectedAccount?.id === row.id ? (
                            <>
                              <CircularProgress size={14} style={{ marginRight: 6, color: 'inherit' }} />
                              Đang tải...
                            </>
                          ) : 'Lịch sử GD'}
                        </Button>
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Thêm tài khoản</DialogTitle>
        <DialogContent>
          <DialogContentText>Điền thông tin cần thiết để thêm mới tài khoản</DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            label="Số tài khoản"
            name="accountNumber"
            placeholder="Nhập số tài khoản"
            fullWidth
            value={newAccount.accountNumber}
            onChange={handleInputChange}
          />
          <Tooltip
            title={
              <div>
                <p>Hướng dẫn set level tài khoản:</p>
                <p>- Tài khoản sẽ hiển thị theo mức level tối thiểu bạn cấu hình</p>
              </div>
            }
            placement="right"
            arrow
            classes={{ tooltip: classes.tooltip }}
          >
            <TextField
              autoFocus
              margin="dense"
              label="Level tài khoản"
              name="accountLevel"
              type="number"
              placeholder="Nhập level tài khoản"
              fullWidth
              value={newAccount.accountLevel}
              onChange={handleInputChange}
              inputProps={{ min: 2, step: 1 }}
            />
          </Tooltip>
          <TextField margin="dense" label="Tên đăng nhập" name="username" fullWidth value={newAccount.username} onChange={handleInputChange} />
          <TextField margin="dense" label="Tên chủ tài khoản" name="ownerName" fullWidth value={newAccount.ownerName} onChange={handleInputChange} />
          <TextField margin="dense" label="Alias number" name="aliasNumber" fullWidth value={newAccount.aliasNumber} onChange={handleInputChange} />
          <TextField margin="dense" label="Alias name" name="aliasName" fullWidth value={newAccount.aliasName} onChange={handleInputChange} />
          <TextField margin="dense" label="Mật khẩu" name="password" fullWidth value={newAccount.password} onChange={handleInputChange} />
          <TextField
            margin="dense"
            label="Ngân hàng"
            name="propType"
            fullWidth
            value={newAccount.propType}
            onChange={handleInputChange}
            InputProps={{ readOnly: true }}
          />
          <CustomizedSwitches state={newAccount.isEnable} handleChange={handleInputChange} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary" disabled={loading.save || loading.delete}>Huỷ</Button>
          <Button onClick={handleAddAccount} color="primary" disabled={loading.save}>
            {loading.save ? (
              <>
                <CircularProgress size={16} style={{ marginRight: 8, color: 'inherit' }} />
                Đang lưu...
              </>
            ) : buttonName}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openConfirmDialog}
        onClose={() => setOpenConfirmDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Xác nhận xoá tài khoản"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {selected.length > 1
              ? `Bạn có chắc chắn muốn xoá ${selected.length} tài khoản đã chọn không?`
              : "Bạn có chắc chắn muốn xoá tài khoản này không?"
            }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirmDialog(false)} color="primary" disabled={loading.delete}>Huỷ</Button>
          <Button onClick={handleConfirmDelete} color="secondary" autoFocus disabled={loading.delete}>
            {loading.delete ? "Đang xoá..." : "Xoá"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openHistoryModal}
        onClose={handleCloseHistoryModal}
        fullWidth
        maxWidth="md"
        aria-labelledby="history-dialog-title"
      >
        <DialogTitle id="history-dialog-title">Lịch sử giao dịch - {selectedAccount?.accountNumber}</DialogTitle>
        <DialogContent>
          <TableContainer component={Paper}>
            <Table stickyHeader aria-label="transaction history table">
              <TableHead>
                <TableRow>
                  <TableCell style={{ minWidth: 120 }}>Ngày</TableCell>
                  <TableCell style={{ minWidth: 120 }}>Thời gian</TableCell>
                  <TableCell>Nội dung</TableCell>
                  <TableCell align="right" style={{ minWidth: 120 }}>Số tiền</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading.history ? (
                  <TableRow>
                    <TableCell colSpan={4} align="center">Đang tải...</TableCell>
                  </TableRow>
                ) : transactions.length > 0 ? (
                  transactions.map((tx, index) => (
                    <TableRow key={index}>
                      <TableCell style={{ minWidth: 120 }}>{tx.date}</TableCell>
                      <TableCell style={{ minWidth: 120 }}>{tx.time}</TableCell>
                      <TableCell>{tx.message}</TableCell>
                      <TableCell
                        align="right"
                        style={{
                          minWidth: 120,
                          whiteSpace: 'nowrap',
                          color: String(tx.amount || '').startsWith('+')
                            ? 'green'
                            : String(tx.amount || '').startsWith('-')
                              ? 'red'
                              : 'inherit',
                          fontWeight: 'bold'
                        }}
                      >
                        {formatAmountWithComma(tx.amount)}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={4} align="center">Không có giao dịch nào.</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseHistoryModal} color="primary">Đóng</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default ManageVietinBank;
